import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_8833_27353)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_8833_27353" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "240.729",
      height: "53.8776",
      fill: "white"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberSystemIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 55,
  },
  height: {
    type: Number as PropType<number>,
    default: 54,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M27.163 2.25996C13.3992 2.25996 2.27877 13.2886 2.27877 26.9388C2.27877 40.589 13.3992 51.6176 27.163 51.6176C40.9267 51.6176 52.0471 40.589 52.0471 26.9388C52.0471 13.2886 40.9267 2.25996 27.163 2.25996ZM27.163 53.8776C12.2142 53.8776 0 41.7641 0 26.9388C0 12.1134 12.2142 0 27.163 0C42.1117 0 54.3259 12.1134 54.3259 26.9388C54.3259 41.7641 42.1117 53.8776 27.163 53.8776Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M35.184 28.2038C34.5459 32.091 31.1733 34.9837 27.1627 34.9837C22.6963 34.9837 19.0503 31.3678 19.0503 26.9382C19.0503 22.5087 22.6963 18.8928 27.1627 18.8928C31.1733 18.8928 34.5459 21.8759 35.184 25.6727L37.2804 24.4975C36.1866 19.9776 32.0848 16.6328 27.1627 16.6328C21.4202 16.6328 16.7715 21.2431 16.7715 26.9382C16.7715 32.6334 21.4202 37.2437 27.1627 37.2437C32.0848 37.2437 36.1866 33.8989 37.2804 29.379L35.184 28.2038Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M29.6234 11.3008L28.4384 13.3799C35.4571 14.0127 40.9261 19.8886 40.9261 26.9397C40.9261 34.4428 34.7279 40.5899 27.1623 40.5899C19.5968 40.5899 13.3986 34.4428 13.3986 26.9397C13.3986 19.8886 18.8676 14.0127 25.8862 13.3799L24.7013 11.3008C17.0446 12.476 11.2109 19.0751 11.2109 26.9397C11.2109 35.7084 18.4119 42.8499 27.2535 42.8499C36.0951 42.8499 43.296 35.7084 43.296 26.9397C43.2049 19.0751 37.2801 12.476 29.6234 11.3008Z",
        fill: __props.color
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M27.1626 5.51562C16.1334 5.51562 7.0183 13.7419 5.74219 24.4089L7.92981 25.6745C8.65902 15.7307 16.9537 7.86599 27.1626 7.86599C37.8273 7.77559 46.4866 16.3635 46.4866 26.9401C46.4866 37.5167 37.8273 46.1046 27.1626 46.1046C16.9537 46.1046 8.65902 38.2399 7.92981 28.2961L5.74219 29.5616C7.0183 40.1383 16.1334 48.3646 27.1626 48.3646C39.1034 48.3646 48.7654 38.7823 48.7654 26.9401C48.7654 15.0979 39.1034 5.51562 27.1626 5.51562Z",
        fill: __props.color
      }, null, 8, _hoisted_6)
    ]),
    _hoisted_7
  ], 8, _hoisted_1))
}
}

})